import { render } from "./SettingEditor.vue?vue&type=template&id=e07f26ba"
import script from "./SettingEditor.vue?vue&type=script&lang=js"
export * from "./SettingEditor.vue?vue&type=script&lang=js"

import exportComponent from "/Users/ions-alpha/Documents/IONS-project/pit-story/vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__